import { render } from "./FormCheckbox.vue?vue&type=template&id=2ab22517&scoped=true"
import script from "./FormCheckbox.vue?vue&type=script&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&lang=js"

import "./FormCheckbox.vue?vue&type=style&index=0&id=2ab22517&scoped=true&lang=css"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab22517"]])

export default __exports__